export default __webpack_public_path__ + "static/media/ssl.5c7a81c0.svg";